import {withdrawChooseMap, WithdrawChooseOption, withdrawOptionMap} from "../loveStoryConst";

/**
 * 选项定义
 * @constructor
 */
export default function ChooseOption(){

    const dataDefine : WithdrawChooseOption[] = [

        {peopleId:"沈瑶瑶",chooseDesc:"一起去看爱情电影",withdrawCoinsPercent:10,withdrawSuccessFlag:false,withdrawReplayContent:"有没有一种可能，穷鬼才需要无聊的爱情片填充空虚",registerDay:0},
        {peopleId:"沈瑶瑶",chooseDesc:"去村口咖啡厅约会",withdrawCoinsPercent:10,withdrawSuccessFlag:false,withdrawReplayContent:"咖啡我只喝星巴克",registerDay:0},
        {peopleId:"沈瑶瑶",chooseDesc:"钢丝球花束",withdrawCoinsPercent:30,withdrawSuccessFlag:true,withdrawReplayContent:"你倒是懂得投我所好",registerDay:0},
        {peopleId:"沈瑶瑶",chooseDesc:"买包纸明天拉屎",withdrawCoinsPercent:1,withdrawSuccessFlag:false,withdrawReplayContent:"这么便宜的纸配不上宝娇贵的屁股",registerDay:0},
        {peopleId:"沈瑶瑶",chooseDesc:"打球渴了买瓶冰红茶",withdrawCoinsPercent:100,withdrawSuccessFlag:false,withdrawReplayContent:"宝是不是背着我养别人了?",registerDay:0},
        {peopleId:"沈瑶瑶",chooseDesc:"爱牛仕背包",withdrawCoinsPercent:100,withdrawSuccessFlag:false,withdrawReplayContent:"宝，咱买得起正版",registerDay:0},

        {peopleId:"沈瑶瑶",chooseDesc:"养只细狗",withdrawCoinsPercent:80,withdrawSuccessFlag:false,withdrawReplayContent:"宝宝，有你就够了。",registerDay:3},
        {peopleId:"沈瑶瑶",chooseDesc:"《如何讨富婆欢心》手册",withdrawCoinsPercent:30,withdrawSuccessFlag:true,withdrawReplayContent:"嘿嘿，好好学~",registerDay:-1},
        {peopleId:"沈瑶瑶",chooseDesc:"孙子兵法",withdrawCoinsPercent:5,withdrawSuccessFlag:false,withdrawReplayContent:"你的脑子看不懂吧",registerDay:-1},

        {peopleId:"薇薇",chooseDesc:"游戏机",withdrawCoinsPercent:80,withdrawSuccessFlag:false,withdrawReplayContent:"天天不学无术玩物丧志！",registerDay:0},
        {peopleId:"薇薇",chooseDesc:"辣条",withdrawCoinsPercent:5,withdrawSuccessFlag:false,withdrawReplayContent:"能不能吃点有档次的。",registerDay:0},
        {peopleId:"薇薇",chooseDesc:"CK内裤",withdrawCoinsPercent:30,withdrawSuccessFlag:true,withdrawReplayContent:"好性感好喜欢~",registerDay:0},
        {peopleId:"薇薇",chooseDesc:"成功学著作",withdrawCoinsPercent:30,withdrawSuccessFlag:false,withdrawReplayContent:"呵呵，白日做梦。",registerDay:0},
        {peopleId:"薇薇",chooseDesc:"爱牛仕皮鞭",withdrawCoinsPercent:80,withdrawSuccessFlag:false,withdrawReplayContent:"救命家人们，我遇到一个下头男！",registerDay:0},
        {peopleId:"薇薇",chooseDesc:"买一份去籽草莓送给亲爱的宝宝",withdrawCoinsPercent:30,withdrawSuccessFlag:true,withdrawReplayContent:"网上说这样才是真爱~",registerDay:0},

        {peopleId:"小芳",chooseDesc:"想吃村口麻辣烫了",withdrawCoinsPercent:5,withdrawSuccessFlag:false,withdrawReplayContent:"吃点有营养的。",registerDay:0},
        {peopleId:"小芳",chooseDesc:"整点奇趣蛋吃吃",withdrawCoinsPercent:50,withdrawSuccessFlag:false,withdrawReplayContent:"那是什么蛋，咱家不是有很多鸡蛋吗？",registerDay:0},
        {peopleId:"小芳",chooseDesc:"东北棉袄在打特价",withdrawCoinsPercent:30,withdrawSuccessFlag:true,withdrawReplayContent:"嘿嘿，咱俩穿同款。",registerDay:0},
        {peopleId:"小芳",chooseDesc:"买个火炕暖暖脚",withdrawCoinsPercent:10,withdrawSuccessFlag:false,withdrawReplayContent:"咱家多的是，给你捎一个。",registerDay:0},
        {peopleId:"小芳",chooseDesc:"养一只细狗",withdrawCoinsPercent:80,withdrawSuccessFlag:false,withdrawReplayContent:"……细狗有你一个就够了。",registerDay:0},
        {peopleId:"小芳",chooseDesc:"烤肠机",withdrawCoinsPercent:30,withdrawSuccessFlag:true,withdrawReplayContent:"最近发家致富小妙招！",registerDay:0},

    ];
    return dataDefine;
}

let wChooseMap:withdrawChooseMap = null;

/**
 * 获取withdrawChooseMap
 * @returns
 */
export function getWithdrawChooseMap(){
    if(!wChooseMap){
        wChooseMap = <withdrawChooseMap>{};
        let chooseAry = ChooseOption();
        for(let choose of chooseAry){
            let people = choose.peopleId;
            let cAry = wChooseMap[people];
            if(!cAry){
                cAry = wChooseMap[people] = <withdrawOptionMap>{};
            }
            wChooseMap[people][choose.chooseDesc] = choose;
        }
    }
    return wChooseMap;
}


/**
 * 获取选项信息
 * @param peopleId 人员标识
 */
export function getChooseOptionsByPeopleId( peopleId : string ) : WithdrawChooseOption[] {
    return ChooseOption().filter( item => item.peopleId == peopleId );
}

export function getChooseOptionByPeopleIdAndId(peopleId:string){
    return getWithdrawChooseMap()[peopleId];
}

/**
 * 获取选项信息 通过 触发天数
 * @param day 触发天数
 */
export function getChooseOptionsByTriggerDay( day : number ) : WithdrawChooseOption[] {
    return ChooseOption().filter( item => item.registerDay == day );
}
